<template>
  <table class="table table-hover table-bordered bg-white table-striped">
      <thead>
          <th>#</th>
          <th>{{ $t('debtors.iin') }} должника</th>
          <th>Изменений</th>
      </thead>
      <tbody>
        <template v-if="!load">
          <tr v-for="(excel, index) in excel.import_debtors" :class="{'table-success': excel.status == 'done', 'table-danger': excel.status == 'failed'}">
              <td>{{index+1}}</td>
              <td>
                {{excel.debtor_iin}}
                <a :href="`/admin/debtors?iin=${excel.debtor_iin}`" target="_blank" title="Найти">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </a>
              </td>
              <td>
                <strong v-if="excel.count && excel.count.created_debts">
                  Кол-во добавленных кредитов: {{excel.count.created_debts}}<br>
                </strong>
                <strong v-if="excel.count && excel.count.updated_debts">
                  Кол-во обновленных кредитов: {{excel.count.updated_debts}}<br>
                </strong>
                <strong v-if="excel.count && excel.count.restored_debts">
                  Кол-во восстановленных кредитов: {{excel.count.restored_debts}}<br>
                </strong>
                <strong v-if="excel.count && excel.count.archived_debts">
                  Кол-во кредитов в архиве: {{excel.count.archived_debts}}<br>
                </strong>
                <strong v-if="excel.count && excel.count.created_phones">
                  Кол-во добавленных телефонов: {{excel.count.created_phones}}<br>
                </strong>
                <strong v-if="excel.count && excel.count.created_addresses">
                  Кол-во добавленных адресов: {{excel.count.created_addresses}}<br>
                </strong>
                <strong v-if="excel.count && excel.count.created_contactfaces">
                  Кол-во добавленных контактных лиц: {{excel.count.created_contactfaces}}<br>
                </strong>
                <strong v-if="excel.count && excel.count.created_workplaces">
                  Кол-во добавленных место работ: {{excel.count.created_workplaces}}<br>
                </strong>
              </td>
          </tr>
        </template>
        <tr v-if="load">
          <td colspan="11" class="text-center">
            <loader-wave/>
          </td>
        </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    excel: Object,
    load: Boolean,
  },
}
</script>
